export default __webpack_public_path__ + "static/media/mind-vault-logo.694b835d.svg";